<template>
  <div class="page">
    <!-- <div class="top">
            <img src='../../../static/err/404.png' />
            <div class="hint">啊呀，页面出错了！</div>
        </div>
        <div class="bottom">
            <div class="btn" @click="Refresh">
                <img src='../../../static/err/refresh.png' />
                <span>点击刷新</span>
            </div>
            <div class="btn" @click="goHome">
                <img src='../../../static/err/home.png' />
                <span>返回首页</span>
            </div>
    </div>-->
  </div>
</template>





<script>
import api from "../../api";
import { mapGetters } from "vuex";
import { mapMutations } from "vuex";
import loadListTail from "../../components/loadListTail";
import Scroll from "../../utils/loading";
export default {
  data() {
    return {};
  },
  activated() {},
  methods: {
    goHome() {
      this.$router.push({ path: "/home/index" });
    },
    Refresh() {
      location.replace(document.referrer);
    }
  }
};
</script>


<style lang="less" scoped>
@import "../../assets/theme.less";
.top {
  text-align: center;
  padding-top: 1.5rem;
  .hint {
    color: #27ba69;
    font-size: 0.38rem;
    margin-top: 0.26rem;
  }
  img {
    max-width: 4rem;
  }
}
.bottom {
  position: absolute;
  bottom: 0px;
  width: 7.5rem;
  height: 6.46rem;
  background: url("../../../static/err/bottomBg.png");
  background-size: 100% 100%;
  padding-top: 2.8rem;
  display: flex;
  justify-content: center;
  img {
    width: 7.5rem;
  }
  .btn {
    border: 1px solid #cbeedb;
    height: 0.8rem;
    width: 2.2rem;
    font-size: 0.3rem;
    color: #cbeedb;
    font-size: 0.3rem;
    display: flex;
    justify-content: center;
    border-radius: 4px;
    margin: 0 0.2rem;
    img {
      max-width: 1em;
      margin: auto 0.5em auto 0;
    }
    span {
      margin: auto 0;
    }
  }
}
</style>







// WEBPACK FOOTER //
// 404.vue?724e32ec